// extracted by mini-css-extract-plugin
export default {"readOnlyContainer":"readOnlyInput_readOnlyContainer__3HyI5","readOnlyLabel":"readOnlyInput_readOnlyLabel__WPm7g","readOnlyValue":"readOnlyInput_readOnlyValue__sT4HO"};